'use client';

import type { Role } from '@svenskaspelab/nova-core/nextjs/auth';
import { useIsLockedToActivatedDraw } from '@svenskaspelab/poolbetting/ui/DrawManager/client';
import { useSearchParams } from 'next/navigation';
import { type ReactNode } from 'react';

type SelectedDrawProps = {
  openDrawComponent: ReactNode;
  selectedDrawComponent: ReactNode;
  role?: Role;
};

/**
 * Handles rendering of either the open draw or selected draw component based on URL search params.
 *
 * @param root0 The component props
 * @param root0.openDrawComponent The component to render when the draw is open
 * @param root0.selectedDrawComponent The component to render when the draw is closed
 * @param root0.role The role of the current user
 * @returns The appropriate component based on the drawOpen search parameter
 */
export default function DrawHandler({ openDrawComponent, selectedDrawComponent, role }: SelectedDrawProps): ReactNode {
  const searchParams = useSearchParams();
  const isLockedToActivatedDraw = useIsLockedToActivatedDraw(role);
  const isDrawOpen = !isLockedToActivatedDraw && searchParams.get('drawOpen')?.toLowerCase() === 'true';

  return (
    <section aria-label="Omgång" className={isDrawOpen ? 'lg:mb-28' : undefined}>
      {isDrawOpen ? openDrawComponent : selectedDrawComponent}
    </section>
  );
}
